import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled/macro';
import { css, keyframes } from '@emotion/react';
import { alpha } from '@mui/material/styles';
import Badge, { badgeClasses } from '@mui/material/Badge';
import PropTypes from 'prop-types';

// `scale` rather than `transform`, which MUI uses to anchor the badge
const pulse = (ring) => keyframes`
  0% { scale: 1; box-shadow: 0 0 0 0 ${ring}; }
  30% { scale: 1.35; }
  100% { scale: 1; box-shadow: 0 0 0 8px transparent; }
`;

const StyledBadge = styled(Badge, { shouldForwardProp: prop => prop !== 'pulsing' })`
  ${({ pulsing, theme }) => pulsing && css`
    & .${badgeClasses.badge} {
      animation: ${pulse(alpha(theme.palette.primary.main, 0.5))} 0.8s ease-out;
    }

    @media (prefers-reduced-motion: reduce) {
      & .${badgeClasses.badge} {
        animation: none;
      }
    }
  `}
`;

const PulseBadge = ({ badgeContent, ...rest }) => {

  const count = Number(badgeContent) || 0;
  const previousCount = useRef(count);
  const [pulsing, setPulsing] = useState(false);

  useEffect(() => {
    if (count > previousCount.current) {
      setPulsing(true);
    }
    previousCount.current = count;
  }, [count]);

  return <StyledBadge badgeContent={badgeContent} pulsing={pulsing} onAnimationEnd={() => setPulsing(false)} {...rest} />;
};

PulseBadge.propTypes = {
  badgeContent: PropTypes.node,
};

export default PulseBadge;
